
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining/articles/[id]",
      function () {
        return require("private-next-pages/dining/articles/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining/articles/[id]"])
      });
    }
  